export default __webpack_public_path__ + "static/media/editCustomAd.86cf4d3d.svg";